import styled, { css } from 'styled-components';
import convertHexToRgba from '~/helpers/convertHexToRgba';

const PlanCardStyled = styled.article.attrs({
  className: 'plan-card',
})`
  ${({
    theme,
    singleProduct,
    expanded,
    expandedIncludedValue,
    skipReward,
    hasFeatureSections,
    isQuizResults,
    showOuterBanner = false,
    is7Gig = false,
    netflixWifiBundleToggled = false,
  }) => {
    const { colors, media } = theme;

    return css`
      --duration: 0.15s;
      border-radius: 2rem;
      margin-bottom: 1.5rem;
      background-color: ${colors.primary.whiteSmoke};
      box-shadow: 0 0 0 2px inset ${colors.primary.whiteSmoke};
      color: ${colors.primary.gravity};
      transition: box-shadow var(--duration) ease-out;
      width: 100%;

      ${media.tablet.up} {
        margin-bottom: 2.5rem;

        ${!showOuterBanner &&
        `
          margin-top: 37px;
        `}
      }

      &:hover {
        box-shadow: 0 0 0 2px transparent inset, 0 0 0 2px ${colors.primary.whiteSmoke};

        .plan-card__banner-outer {
          box-shadow: 0 0 0 2px transparent inset, 0 0 0 2px ${colors.primary.darkBlue};
        }
        .plan-card__banner-inner {
          box-shadow: 0 0 0 2px transparent inset, 0 0 0 2px ${colors.primary.darkBlue};
        }
      }

      /* Plan Card
      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
      .plan-card {
        &__banner-outer,
        &__banner-inner {
          text-align: center;
          border-radius: 2rem 2rem 0 0;
          padding-top: 8px;
          padding-bottom: 8px;
          padding-left: 11px;
          padding-right: 11px;
          font-size: 0.75rem;
          line-height: 0.875rem;
          font-weight: 700;
          transition: box-shadow var(--duration) ease-out;

          &.gravity {
            background-color: ${colors.primary.gravity};
            color: ${colors.primary.white};
            box-shadow: 0 0 0 2px inset ${colors.primary.darkBlue};
          }

          &.electricity {
            background-color: ${colors.primary.electricity};
            color: ${colors.primary.gravity};
            box-shadow: 0 0 0 2px inset ${colors.primary.electricity};
          }

          &.white {
            background-color: ${colors.primary.white};
            color: ${colors.primary.gravity};
            box-shadow: 0 0 0 2px inset ${colors.primary.whiteSmoke};
          }
        }
        &__banner-inner {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          &-icon {
            padding-right: 0.5rem;
            height: 15px;
            width: 16px;
            color: red;
          }
        }

        &__padded {
          padding-left: ${netflixWifiBundleToggled ? '1rem' : '1.5rem'};
          padding-right: ${netflixWifiBundleToggled ? '1rem' : '1.5rem'};
          padding-bottom: ${hasFeatureSections && !isQuizResults ? '2rem' : '0.5rem'};
          position: relative;
        }

        &__header {
          padding-top: 4.25rem;
          padding-bottom: 1rem;
          margin-bottom: 1.25rem;
        }

        &__headerWithInnerBanner {
          padding-top: 2.15rem;
          padding-bottom: 1rem;
          margin-bottom: 1.25rem;
        }

        &__limited-time {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: ${colors.primary.red};
          color: ${colors.primary.whiteSmoke};
          border-radius: 0rem 0.5rem 0.5rem 0rem;
          padding: 4px 16px 4px 8px;
          height: 1rem;
          width: fit-content;
          position: absolute;
          bottom: 0.75rem;
          font-size: 0.776rem;

          svg {
            padding: 0 0.3rem 0 0.3rem;
            height: 1rem;
            width: 1rem;
            path {
              fill: ${colors.primary.whiteSmoke};
            }
          }
        }

        &__sweetener {
          line-height: 1.25;
        }

        &__speed {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          text-align: center;

          small {
            font-size: 0.75rem;
            font-weight: 500;
            display: block;
            margin-top: 0.25rem;
          }
        }

        /* Netflix Bundle
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
        &__netflix-bundle {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 8px 0;
          position: absolute;
          left: 0;
          top: 110px;
          background-color: ${colors.primary.whiteSmoke};
          color: ${colors.primary.white};
          margin: 8px 0;
          min-height: 44px;
          text-align: center;
          width: -webkit-fill-available;

          ${media.tablet.up} {
            padding: 8px 14px;
          }
        }

        &__netflix-bundle-name {
          color: ${colors.primary.gravity};
          display: flex;
          font-size: 12px;
          line-height: 20px;
          font-weight: 700;
          white-space: nowrap;

          img {
            margin-right: 4px;
          }
        }

        &__netflix-bundle-description {
          color: ${colors.primary.gravity};
          font-size: 10px;
          line-height: 12px;
          font-weight: 500;

          button {
            border: none;
            cursor: pointer;
            font-size: 10px;
            line-height: 12px;
            font-weight: 500;
            padding: 0;
            text-decoration: underline;
          }
        }

        /* Card Price + Legal
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
        &__price-container {
          display: grid;
          grid-template-columns: auto auto;
          margin-bottom: 0.5rem;

          &--margin-top {
            margin-top: 80px;
          }
        }

        &__price {
          grid-row: auto / span 2;
          white-space: nowrap;
          display: flex;
          justify-content: flex-end;
          flex-direction: row;

          .pre {
            font-size: 1.25rem;
            font-weight: 700;
            transform: translateY(0.25rem);
          }
        }

        &__cents {
          font-size: 0.6875rem;
          font-weight: 700;

          .annotation {
            font-size: 0.5rem;
            font-weight: 400;
            position: relative;
            top: -2px;
          }
        }

        &__dollars {
          font-size: 56px;
          line-height: 1;
          white-space: nowrap;
          font-weight: 700;

          /* Crop top/bottom line-height whitespace; Simplified version of this:
            https://medium.com/eightshapes-llc/cropping-away-negative-impacts-of-line-height-84d744e016ce
          */
          &:before,
          &:after {
            content: '';
            display: block;
            height: 0;
            width: 0;
          }
          &:before {
            margin-bottom: -0.075em;
          }
          &:after {
            margin-top: -0.15em;
          }
        }

        &__full-price {
          display: flex;
          align-items: flex-end;
          color: ${colors.primary.gray};
          font-weight: 500;
          font-size: 0.625rem;
          text-decoration-line: line-through;
          text-decoration-color: ${colors.primary.red};
        }

        &__legal-text {
          font-size: 0.625rem;
          line-height: 1.25;
          min-height: 1rem;
          padding-top: 0.25rem;
          padding-bottom: 1.25rem;
          padding-right: ${netflixWifiBundleToggled ? 0 : '2rem'};
          padding-left: ${netflixWifiBundleToggled ? 0 : '2rem'};
          text-align: center;

          .consumer-label {
            padding-top: 0.25rem;
            border: 0;
            background: none;
            padding: 4px;
            font: inherit;
            text-decoration: underline;
            cursor: pointer;
          }

          ${netflixWifiBundleToggled && `
            sup {
              line-height: 8px;
            }
          `}
        }

        /* CTA Buttons
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
        &__ctas {
          display: flex;
          gap: 0.5rem;
          justify-content: center;
        }

        &__button {
          font-weight: 700;
          font-size: 1.125rem;
          line-height: 1;
          padding: 1rem 0.5rem;
          text-transform: uppercase;
          width: 100%;
          max-height: 3.125rem;

          &.netflix-with-7gig {
            font-size: 12px;
            text-transform: none;
            padding: 19px 8px;

            &:hover {
              border-color: transparent;
              text-decoration: none;
            }
          }
        }

        /* Feature Sections
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
        &__feature-section {
          font-size: 0.75rem;
          padding-bottom: 2rem;

          &.hidden {
            padding-bottom: 0.5rem;
          }

          .header {
            display: flex;
            align-items: center;
            position: relative;
            padding-bottom: 0.75rem;
            margin-bottom: 0.75rem;
            border-bottom: 2px solid ${convertHexToRgba(colors.primary.gray, 0.25)};

            .product-filters {
              position: absolute;
              bottom: 0%;
              left: 45%;
              margin-bottom: 5px;

              &__sweetener {
                width: 150px;

                ${media.tablet.up} {
                  flex: 0 0 150px;
                }
              }

              &__select {
                svg {
                  color: ${colors.primary.gravity};
                }
              }
            }
          }
        }

        /* Features List
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
        &__features-container {
          transition: height var(--duration) ease-out;
        }

        ${!hasFeatureSections &&
        css`
          &__features {
            display: flex;
            flex-direction: column;
            padding-bottom: 2rem;
          }
        `}

        &__feature {
          font-size: 0.75rem;
          font-weight: 500;
          line-height: 1.33;
          margin-bottom: 1rem;
          position: relative;
          list-style: none;

          &.w-icon {
            padding-left: 1.5rem;
          }

          &:not(.w-icon) {
            .icon--fill-check {
              display: none;
            }
          }

          .icon--outline-info-circle {
            height: auto;
          }

          &--included-value {
            font-size: 12px;
            font-weight: 500;
            line-height: 16px;
            justify-content: space-between;
            margin-bottom: 6px;

            .heading {
              font-weight: 700;
            }

            button {
              cursor: pointer;
              display: flex;
              font-size: 12px;
              font-weight: 700;
              text-decoration: none;
              justify-content: space-between;
              width: 100%;
              align-items: center;
              background: none;
              border: none;
              bottom: 0;
              color: inherit;
              padding: 0;

              .icon--fill-chevron-down {
                height: auto;
                margin-left: 5px;
                width: 14px;
                transition: transform var(--duration) ease-out;
                ${expandedIncludedValue && `transform: rotate(-0.5turn);`}
              }
            }

            .disclosure,
            &.disclosure {
              font-size: 10px;
              font-weight: 400;
              line-height: 14px;
              margin: 10px 0 16px;
            }
          }

          button {
            background: none;
            border: none;
            color: inherit;
            cursor: pointer;
            font: inherit;
            padding: 0;
            text-align: inherit;
            text-decoration: underline;
          }

          sup {
            line-height: 0;
          }

          strong {
            font-size: 0.875rem;
          }

          .icon--fill-check {
            position: absolute;
            top: 50%;
            left: 0;
            width: 14px;
            transform: translateY(-50%);
          }

          &.consumer-label {
            flex: 1;
            display: flex;
            align-items: end;

            button {
              padding: 0;
              border: 0;
              background: none;
              font: inherit;
            }
          }
        }

        &__feature-section.hidden,
        &__feature.hidden {
          opacity: 0;
          pointer-events: none;
          transition: opacity calc(var(--duration) / 2) ease-out;
        }

        &__feature-section.hidden.expanded,
        &__feature.hidden.expanded {
          opacity: 1;
          pointer-events: auto;
          transition: opacity var(--duration) ease-out var(--duration);
        }

        &__feature-toggle {
          align-items: center;
          background: none;
          border: none;
          bottom: 0;
          color: inherit;
          cursor: pointer;
          display: flex;
          font-size: 0.75rem;
          font-weight: 500;
          justify-content: center;
          left: 0;
          min-height: 50px;
          position: absolute;
          width: 100%;

          ${singleProduct && `display: none;`}

          .toggle-text {
            margin-right: 0.625rem;
          }

          .icon--fill-chevron-down {
            height: auto;
            width: 17px;
            transition: transform var(--duration) ease-out;
            ${expanded && `transform: rotate(-0.5turn);`}
          }

          .icon--fill-chevron-right {
            height: 17px;
            width: auto;
          }

          .icon--fill-chevron-left {
            height: 17px;
            width: auto;
          }
        }

        &__footer-banner {
          background-color: #eafffd;
          border-radius: 0 0 2rem 2rem;
          padding: 16px 24px;
          font-size: 1rem;
          line-height: 1.25rem;
          font-weight: 700;
          text-align: center;
        }
      }

      /* Theme v1
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
      &.theme-1 {
        &.hasBanner {
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          will-change: box-shadow;

          .plan-card {
            &__banner-wrapper {
              background: ${colors.primary.electricity};
            }
            /* margin-top: 40px; */
          }
        }

        .plan-card {
          &__header {
            padding-top: 2.75rem;
          }

          &__banner-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            border-top-left-radius: 2rem;
            border-top-right-radius: 2rem;
            color: ${colors.primary.gravity};
            font-size: 0.625rem;
            font-weight: 700;
            min-height: 2rem;
            transition: transform var(--duration) ease-out;

            sup {
              font-weight: 400;
              font-size: 80%;
              line-height: 0;
            }
          }

          &__banner {
            max-width: 200px;
          }

          &__sweetener {
            line-height: 1;

            small {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 2px;

              span {
                color: ${colors.primary.red};
                font-weight: 700;
                margin-right: 2px;
              }

              .tooltip {
                svg {
                  height: 10px;
                }

                .tooltip-button {
                  margin: 0;
                }
              }
            }
          }

          &__featured-header {
            position: absolute;
            top: -2rem;
            left: 0;
            right: 0;
            display: flex;
            font-weight: 500;
            flex-direction: column;
            text-align: center;
            transition: left var(--duration) ease-out, right var(--duration) ease-out;
          }
        }
      }

      &.featured.theme-1 {
        background-color: ${colors.primary.gravity};
        color: ${colors.primary.white};
        box-shadow: 0 0 0 4px ${colors.primary.electricity}, 0 0 0 8px transparent;
        border-top-left-radius: ${skipReward ? '2rem' : 0};
        border-top-right-radius: ${skipReward ? '2rem' : 0};
        will-change: box-shadow;

        &:hover {
          box-shadow: 0 0 0 4px ${colors.primary.gravity}, 0 0 0 8px ${colors.primary.electricity};
        }

        .plan-card {
          &__featured-header {
            left: -4px;
            right: -4px;
          }

          &__banner-wrapper {
            background: ${skipReward ? 'none' : colors.primary.electricity};
          }

          &__feature-section {
            .header {
              border-bottom-color: ${convertHexToRgba(colors.primary.white, 0.5)};
            }
          }

          &__best-value {
            padding-top: 1rem;
            font-size: 0.75rem;

            .icon--star {
              margin-right: 0.25rem;
              width: 0.875rem;
              height: auto;
              vertical-align: bottom;
            }
          }

          &__full-price {
            color: ${colors.primary.white};
          }
        }

        &:hover {
          .plan-card__featured-header {
            left: -8px;
            right: -8px;
          }
          .plan-card__banner-wrapper {
            transform: translateY(-4px);
          }
        }
      }

      /* Theme v2 & Theme v3 & Theme v4
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
      &.theme-2,
      &.theme-3,
      &.theme-4 {
        .plan-card {
          &__featured-header {
            position: absolute;
            border-radius: 2rem 2rem 0 0;
            overflow: hidden;
            inset: 0 0 auto 0;
            display: flex;
            flex-direction: row;
            font-weight: 700;
            justify-content: ${is7Gig ? 'flex-end' : 'space-between'};
            height: 60px;
            transition: border-radius var(--duration) ease-out;
          }

          &__banner-wrapper {
            position: relative;
            align-items: center;
            display: flex;
            justify-content: center;
            font-size: 0.625rem;
            padding-left: 1rem;
            width: 100%;

            sup {
              font-weight: 400;
              font-size: 80%;
              line-height: 0;
            }
          }

          &__sweetener {
            padding-bottom: 1.5rem;
            small {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 2px;

              span {
                color: ${colors.primary.red};
                font-weight: 700;
                margin-right: 2px;
              }
            }

            .tooltip {
              svg {
                height: 10px;
              }

              .tooltip-button {
                margin: 0;
              }
            }
          }
        }
      }

      &.theme-2 {
        ${netflixWifiBundleToggled &&
        `
          background-color: ${colors.primary.white};
          border: 2px solid ${colors.secondary.pumice};
          box-shadow: none;
        `}
      }

      /* new product flag */
      &.new.theme-2,
      &.new.theme-3,
      &.new.theme-4 {
        .plan-card {
          &__banner-wrapper {
            flex: 0 0 50%;
          }

          &__best-value {
            position: relative;
            flex: 0 0 50%;

            span {
              background-color: ${colors.primary.electricity};
              border-top-left-radius: 2rem;
              border-bottom-left-radius: 2rem;
              display: inline-block;
              font-size: 0.75rem;
              padding: 0.5rem 1rem;
              padding-right: 1.75rem;
              position: absolute;
              transform: translateY(-50%);
              top: 50%;
              right: 0;
              white-space: nowrap;
            }
          }
        }
      }

      &.featured.theme-2,
      &.featured.theme-3,
      &.featured.theme-4 {
        position: relative;
        background-color: ${colors.primary.white};
        box-shadow: none;

        &:after {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 2rem;
          pointer-events: none;
          box-shadow: 0 0 0 2px inset ${colors.primary.gravity};
          transform: rotate(0.01deg);
          transition: transform var(--duration) ease-out;
          will-change: transform;
        }

        .plan-card {
          &__banner-wrapper {
            flex: 0 0 50%;
          }

          &__best-value {
            position: relative;
            flex: 0 0 50%;

            span {
              background-color: ${colors.primary.electricity};
              border-top-left-radius: 2rem;
              border-bottom-left-radius: 2rem;
              display: inline-block;
              font-size: 0.75rem;
              padding: 0.5rem 1rem;
              padding-right: 1.75rem;
              position: absolute;
              transform: translateY(-50%);
              top: 50%;
              right: 0;
              white-space: nowrap;
            }
          }
        }

        &:hover .plan-card__featured-header {
          border-top-right-radius: 1.75rem;
        }

        &:hover:after {
          transform: scale(1.01) rotate(0.01deg);
        }
      }

      /* Base Card: Theme v3
      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
      &.theme-3:not(.featured) {
        padding-left: 0;
        padding-right: 0;
        transition: background-color var(--duration) ease-out;

        .plan-card {
          &__header {
            position: relative;
            padding-left: 1.5rem;
            padding-right: 1.5rem;
            border-radius: 2rem;
            background-color: ${colors.primary.white};

            &:after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              border-radius: 2rem;
              pointer-events: none;
              box-shadow: 0 0 0 2px inset ${convertHexToRgba(colors.primary.gravity, 0.25)};
              transform: rotate(0.01deg);
              transition: transform var(--duration) ease-out, bottom 1s ease-out;
              will-change: transform, bottom;
            }
          }

          &__features-container {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
          }

          &__feature-section:not(.hidden) {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
          }
        }

        &:hover,
        &.selected {
          background-color: ${colors.primary.white};

          .plan-card__header {
            position: static;

            &:after {
              transform: scale(1.01) rotate(0.01deg);
            }
          }
        }
      }

      /* Theme v4
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
      &.theme-4 {
        &.plan-card {
          backface-visibility: hidden;
          min-width: 100%;
          padding: 0;
        }

        .plan-card {
          &__button {
            background-color: ${colors.primary.gravity};
            border-color: ${colors.primary.gravity};
            color: ${colors.primary.white};
          }

          &__header {
            padding-bottom: 0;
            margin-bottom: 0;
          }

          &__legal-text {
            padding-bottom: 0;
          }

          &__feature-section {
            padding-bottom: 0;
          }

          &__features-container {
            padding: 0 24px;
          }

          &__feature:last-of-type {
            margin-bottom: 0;
          }

          &__feature-toggle {
            background-color: ${colors.primary.electricity};
            color: ${colors.primary.gravity};
            border-radius: 0 0 2rem 2rem;
            padding: 0;
            min-height: 40px;
          }

          &__ctas {
            padding: 1.25rem 1.25rem 4rem;

            &__ag-mn {
              padding: 1.25rem 1.25rem 4rem;
              position: relative;
              top: 1rem;
              display: flex;
            }
          }
        }
      }

      &.backCard.theme-4 {
        background-color: ${colors.primary.gravity};
        color: ${colors.primary.white};
        transform: rotateY(-180deg) translate(100%, 0);

        .plan-card {
          &__button {
            background-color: ${colors.primary.white};
            border-color: ${colors.primary.white};
            color: ${colors.primary.gravity};
          }

          &__header {
            padding-top: 2.5rem;
            padding-bottom: 0;
            margin-bottom: 0;
          }

          &__speed {
            margin-bottom: 0;
          }

          &__features {
            padding-bottom: 0;
          }

          &__feature-toggle {
            background-color: ${colors.primary.electricity};
            color: ${colors.primary.gravity};
            border-radius: 0 0 2rem 2rem;
            padding: 0;
            min-height: 40px;
          }
        }
      }

      &.featured.theme-2 {
        ${netflixWifiBundleToggled &&
        `
          border: none;
        `};
      }

      &.featured.theme-4 {
        .plan-card {
          &__button {
            background-color: ${colors.primary.gravity};
            border-color: ${colors.primary.gravity};
            color: ${colors.primary.white};
          }
        }
      }
    `;
  }}
`;

export default PlanCardStyled;
